import { render, staticRenderFns } from "./EditMedicationsDialog.vue?vue&type=template&id=119d24e0&scoped=true"
import script from "./EditMedicationsDialog.vue?vue&type=script&lang=js"
export * from "./EditMedicationsDialog.vue?vue&type=script&lang=js"
import style0 from "./EditMedicationsDialog.vue?vue&type=style&index=0&id=119d24e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119d24e0",
  null
  
)

export default component.exports